import { render, staticRenderFns } from "./BusinessGuideStepCard.vue?vue&type=template&id=01525950&scoped=true"
import script from "./BusinessGuideStepCard.vue?vue&type=script&lang=js"
export * from "./BusinessGuideStepCard.vue?vue&type=script&lang=js"
import style0 from "./BusinessGuideStepCard.vue?vue&type=style&index=0&id=01525950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01525950",
  null
  
)

export default component.exports